import { put, takeLatest, all } from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import CNActions, { cnActionTypes } from '../actions/cnActions';
import CNServices from '../services/cnServices';

/**
 * @param action
 */
function* _createCN(action) {
  try {
    yield put(CNActions.createCNLoading(true));
    const cn = yield CNServices.createCN(action.payload);
    if (cn.success) {
      yield put(TrackerActions.trackAction(cnActionTypes.CREATE_CN.SUCCESS, cn.data));
      notification.open({
        type: 'success',
        message: `${action?.payload?.[0]?.doc_type === 'RETURN_SLIP' ? 'Return Slip' : 'Credit Note'} successfully created`,
        duration: 4,
        placement: 'top',
      });
      action.callback(cn?.data?.[0]);
      yield put(CNActions.createCNLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: cn.message,
        duration: 4,
        placement: 'top',
      });
      yield put(CNActions.createCNLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(CNActions.createCNLoading(false));
    yield put(TrackerActions.trackAction(cnActionTypes.CREATE_CN.ERROR, error));
  }
}

/**
 *
 */
function* createCN() {
  yield takeLatest(cnActionTypes.CREATE_CN.REQUEST, _createCN);
}

/**
 * @param action
 */
function* _updateCN(action) {
  try {
    yield put(CNActions.updateCNLoading(true));
    const cn = yield CNServices.updateCN(action.payload);
    if (cn.success) {
      yield put(TrackerActions.trackAction(cnActionTypes.UPDATE_CN.SUCCESS, cn.data));
      notification.open({
        type: 'success',
        message: `${action?.payload?.[0]?.doc_type === 'RETURN_SLIP' ? 'Return Slip' : 'Credit Note'} successfully updated`,
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(CNActions.updateCNLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: cn?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(CNActions.updateCNLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.UPDATE_CN.ERROR, error));
  }
}

/**
 *
 */
function* updateCN() {
  yield takeLatest(cnActionTypes.UPDATE_CN.REQUEST, _updateCN);
}

/**
 * @param action
 */
function* _getCN(action) {
  try {
    CNActions.getCNSuccess(null);
    yield put(CNActions.getCNLoading(true));
    const {
      tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list
    } = action;
    const creditNotes = yield CNServices.getCN(tenantId, cnId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, accountManagerIds, docType, is_list);
    yield put(CNActions.getCNSuccess(creditNotes));
    yield put(CNActions.getCNLoading(false));
  } catch (error) {
    yield put(CNActions.getCNLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.GET_CN.ERROR, error));
  }
}

/**
 *
 */
function* getCN() {
  yield takeLatest(cnActionTypes.GET_CN.REQUEST, _getCN);
}

/**
 * @param action
 */
function* _getCNById(action) {
  try {
    yield put(CNActions.getCNByIdLoading(true));
    const {
      tenantId, cnId, docType,
    } = action;
    const selectedCN = yield CNServices.getCN(tenantId, cnId, 1, 10, '', '', '', '', '', '', '', docType);
    yield put(CNActions.getCNByIdSuccess(selectedCN));
    yield put(CNActions.getCNByIdLoading(false));
  } catch (error) {
    yield put(CNActions.getCNByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.GET_CN_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getCNById() {
  yield takeLatest(cnActionTypes.GET_CN_BY_ID.REQUEST, _getCNById);
}

/**
 * @param action
 */
function* _updateCNStatus(action) {
  try {
    yield put(CNActions.updateCNStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const cn = yield CNServices.updateCNStatus(payload);

    if (cn.success) {
      notification.open({
        type: 'success',
        message: `${action?.payload?.doc_type === 'RETURN_SLIP' ? 'Return Slip' : 'Credit Note'} successfully updated`,
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: cn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CNActions.updateCNStatusLoading(false));
  } catch (error) {
    yield put(CNActions.updateCNStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.UPDATE_STATUS_CN.ERROR, error));
  }
}

/**
 *
 */
function* updateCNStatus() {
  yield takeLatest(cnActionTypes.UPDATE_STATUS_CN.REQUEST, _updateCNStatus);
}

/**
 * @param action
 */
function* _deleteCN(action) {
  try {
    yield put(CNActions.deleteCNLoading(true));
    const cn = yield CNServices.deleteCN(action.payload);

    if (cn.success) {
      notification.open({
        type: 'success',
        message: `${action?.payload?.doc_type === 'RETURN_SLIP' ? 'Return Slip' : 'Credit Note'} successfully deleted`,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: cn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CNActions.deleteCNLoading(false));
  } catch (error) {
    yield put(CNActions.deleteCNLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.DELETE_CN.ERROR, error));
  }
}

/**
 *
 */
function* deleteCN() {
  yield takeLatest(cnActionTypes.DELETE_CN.REQUEST, _deleteCN);
}

/**
 * @param action
 */
function* _updateCNWorkflowStep(action) {
  try {
    yield put(CNActions.updateCNWorkflowStepLoading(true));
    const so = yield CNServices.updateCNWorkflowStep(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: `${action?.payload?.[0]?.doc_type === 'RETURN_SLIP' ? 'Return Slip' : 'Credit Note'} successfully updated`,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CNActions.updateCNWorkflowStepLoading(false));
  } catch (error) {
    yield put(CNActions.updateCNWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.UPDATE_CN_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updateCNWorkflowStep() {
  yield takeLatest(cnActionTypes.UPDATE_CN_WORKFLOW_STEP.REQUEST, _updateCNWorkflowStep);
}

function* _linkPaymentToCn(action) {
  try {
    yield put(CNActions.linkPaymentToCnLoading(true));
    const so = yield CNServices.linkPaymentToCn(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Payment successfully linked to Credit Note',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CNActions.linkPaymentToCnLoading(false));
  } catch (error) {
    yield put(CNActions.linkPaymentToCnLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cnActionTypes.LINK_PAYMENT_TO_CN.ERROR, error));
  }
}

/**
 *
 */
function* linkPaymentToCn() {
  yield takeLatest(cnActionTypes.LINK_PAYMENT_TO_CN.REQUEST, _linkPaymentToCn);
}

/**
 *
 */
export default function* cnSaga() {
  yield all([
    createCN(), getCN(), updateCN(), getCNById(), updateCNStatus(), deleteCN(), updateCNWorkflowStep(), linkPaymentToCn(),
  ]);
}
